<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                floralVarietyForm: () => import('../forms/FloralVarietyForm'),
                fields: [
                    { type: 'text', text: 'Name', value: 'name', rules: [v => !!v || 'Name is required', v => !(v && v.length > 100) || 'Name must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'autocomplete', text: 'Floral Variety', value: 'floralVarietyId', rules: [v => !!v || 'Floral Variety is required'], isRequired: true, form: () => import('./FloralVarietyForm'), apiMethod: 'FloralVarieties', claim: 'FloralVarieties' },
                ],
                apiMethod: 'FloralVarietyNicknames',
                formTitle: 'Floral Variety Nickname',
            }
        },
    };
</script>
